<template>
  <div class="diagnosis-details">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/home">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <router-link to="/diagnosis">就诊流程</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>就诊详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="diagnosis-content">
      <div class="header">
        <div class="left">
          <span class="name">{{ detailsData.patientName || "- -" }}</span>
          <span class="sex">
            <a-icon v-if="detailsData.sexName == '女'" type="woman" />
            <a-icon v-if="detailsData.sexName == '男'" type="man" />
            <span class="set-text">{{ detailsData.sexName }}</span>
          </span>
          <span v-if="detailsData.isInGroup == 1" class="group">已入组</span>
          <span class="create-date">
            <span class="title">出生日期</span>
            <span class="value">{{
              detailsData.ageBirthDay
              ? detailsData.ageBirthDay.split(" ")[0]
              : "- -"
            }}</span>
          </span>
        </div>
        <div class="right">
          <span class="right-group">
            <span class="right-group-title">流程ID:</span>
            <span class="right-group-value">{{ detailsData.id }}</span>
          </span>
          <span class="right-group">
            <span class="right-group-title">协作组条码:</span>
            <span class="right-group-value">{{ detailsData.hosBarCode }}</span>
          </span>
        </div>
      </div>
      <div class="content">
        <a-row>
          <a-col :span="8">
            <span class="right-group">
              <span class="right-group-title">就诊医院:</span>
              <span class="right-group-value">{{
                detailsData.hospitalName || "- -"
              }}</span>
            </span>
          </a-col>
          <a-col :span="8">
            <span class="right-group">
              <span style="width: 100.23px" class="right-group-title">门诊号:</span>
              <span class="right-group-value">{{
                detailsData.patientNo || "- -"
              }}</span>
            </span>
          </a-col>
          <a-col :span="8">
            <span class="right-group">
              <span style="width: 68.23px" class="right-group-title">就诊日期:</span>
              <span class="right-group-value">{{
                detailsData.seeDoctorTime || "- -"
              }}</span>
            </span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <span class="right-group">
              <span class="right-group-title">测序中心:</span>
              <span class="right-group-value">{{
                detailsData.deptName || "- -"
              }}</span>
            </span>
          </a-col>
          <a-col :span="8">
            <span class="right-group">
              <span class="right-group-title">测序中心条码:</span>
              <span class="right-group-value">{{
                detailsData.barCode || "- -"
              }}</span>
            </span>
          </a-col>
          <a-col :span="8">
            <span class="right-group">
              <span class="right-group-title">检测项目:</span>
              <span class="right-group-value">{{
                detailsData.applyItemNameDict || "- -"
              }}</span>
            </span>
            <!--<span class="right-group">-->
            <!--<span style="width:68.23px" class="right-group-title">专业组:</span>-->
            <!--<span class="right-group-value">{{detailsData.groupName||'- -'}}</span>-->
            <!--</span>-->
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <span class="right-group">
              <span style="width: 100.23px" class="right-group-title">样本类型:</span>
              <span class="right-group-value">{{
                detailsData.sampleTypeNameDict || "- -"
              }}</span>
            </span>
          </a-col>
          <a-col :span="8">
            <span class="right-group">
              <span style="width: 68.23px" class="right-group-title">样本量:</span>
              <span class="right-group-value">{{
                detailsData.sampleAmount
                ? detailsData.sampleAmount + " ml"
                : "- -"
              }}</span>
            </span>
          </a-col>
          <a-col :span="8">
            <span class="right-group">
              <span class="right-group-title">采样日期:</span>
              <span class="right-group-value">{{
                detailsData.sampleCollectionTime || "- -"
              }}</span>
            </span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <span class="right-group">
              <span class="right-group-title">更新日期:</span>
              <span class="right-group-value">{{
                detailsData.updateTime || "- -"
              }}</span>
            </span>
          </a-col>
          <a-col :span="8">
            <span class="right-group">
              <span class="right-group-title">录入时间:</span>
              <span class="right-group-value">{{
                detailsData.createTime || "- -"
              }}</span>
            </span>
          </a-col>
          <a-col :span="8">
            <span class="right-group">
              <span class="right-group-title">完成日期:</span>
              <span class="right-group-value">{{
                detailsData.endTime || "- -"
              }}</span>
            </span>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="steps-div">
      <a-row>
        <a-col :span="8">
          <span class="record-group">
            <span class="record-title">MD审核状态</span>
            <a class="record-link" v-if="detailsData.mdCheck != '未审核'" @click="recordToggle('mdCheckToggle')"><a-icon
                v-if="mdCheckToggle.show" type="minus-square"></a-icon>
              <a-icon v-else type="plus-square"></a-icon></a>
            <b class="record-none" v-else>未审核</b>
          </span>
        </a-col>
        <a-col :span="16">
          <a-button v-auth="'102091'" @click="mdToExamine()" type="primary">MD审核</a-button>
        </a-col>
        <a-col :span="24">
          <md-to-logs v-if="mdCheckToggle.show" :itemId="detailsData.id" :authCode1="102092" :authCode2="102093"
            ref="mdToLogs"></md-to-logs>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <span class="record-group">
            <span class="record-title">质控记录</span>
            <a class="record-link" v-if="qcRecordData.length > 0" @click="recordToggle('qcToggle')">{{ qcToggle.text
            }}</a>
            <b class="record-none" v-else>无</b>
          </span>
        </a-col>
        <a-col :span="24">
          <div class="page-content" v-if="qcToggle.show">
            <div class="panel-page panel-page2">
              <div class="panel-tip">
                <div class="content-item">
                  <a-table :columns="columns1" :rowKey="(record) => record.id" :dataSource="qcRecordData"
                    :pagination="false">
                  </a-table>
                </div>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <span class="record-group">
            <span class="record-title">备注记录</span>
            <a class="record-link" v-if="remarkData.length > 0" @click="recordToggle('remarkToggle')">{{ remarkToggle.text
            }}</a>
            <b class="record-none" v-else>无</b>
          </span>
        </a-col>
        <a-col :span="24">
          <div class="page-content" v-if="remarkToggle.show">
            <div class="panel-page panel-page2">
              <div class="panel-tip">
                <div class="content-item">
                  <a-table :columns="columns2" :rowKey="(record) => record.id" :dataSource="remarkData"
                    :pagination="false">
                  </a-table>
                </div>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <span class="record-group">
            <span class="record-title">常规检查结果</span>
            <a class="record-link" v-if="detailsData.remark" @click="recordToggle('resultToggle')">{{ resultToggle.text
            }}</a>
            <b class="record-none" v-else>无</b>
          </span>
        </a-col>
        <a-col :span="24">
          <div class="page-content" v-if="resultToggle.show">
            <span v-html="detailsData.remark || '- -'"></span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <span class="record-group">
            <span class="record-title">临床诊断</span>
            <a class="record-link" v-if="detailsData.clinicalDiagnosis" @click="recordToggle('clinicalToggle')">{{
              clinicalToggle.text }}</a>
            <b class="record-none" v-else>无</b>
          </span>
        </a-col>
        <a-col :span="24">
          <div class="page-content" v-if="clinicalToggle.show">
            <span v-html="detailsData.clinicalDiagnosis || '- -'"></span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <span class="record-group">
            <span class="record-title">分子分型</span>
            <a class="record-link" v-if="detailsData.molecularTyping" @click="recordToggle('molecularToggle')">{{
              molecularToggle.text }}</a>
            <b class="record-none" v-else>无</b>
          </span>
        </a-col>
        <a-col :span="24">
          <div class="page-content" v-if="molecularToggle.show">
            {{ filterMolecularTyping(detailsData.molecularTyping) }}
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="steps-div">
      <div class="steps-div-content">
        <h-process v-if="detailsData.id" :bid="detailsData.id"
          :IsSuffer="detailsData.trackingStatus == 'waiting' ? 1 : 0"></h-process>
      </div>
    </div>
    <page-model @close="closeModel" :visible="backZJVisible">
      <md-to-examine v-if="backZJVisible && isAppoint == 4" @close="closeModel" @update="update"
        :selectedData="selectRows" :selectedId="detailsData.id"></md-to-examine>
    </page-model>
  </div>
</template>

<script>
import HProcess from "@/components/common/process.vue";
import MdToExamine from "../report/md-to-examine.vue";
import MdToLogs from "../report/md-to-logs.vue";

const columns1 = [
  {
    title: "序号",
    width: "100px",
    customRender: (text, record, index) => `${index + 1}`,
  },
  {
    title: "质控时间",
    dataIndex: "qcTime",
    customRender: (text, record, index) => {
      if (!record.qcTime) {
        return "-";
      } else {
        return record.qcTime;
      }
    },
  },
  {
    title: "质控状态",
    dataIndex: "qcStatus",
    width: "15%",
    customRender: (text, record, index) => {
      if (!record.qcStatus) {
        return "-";
      } else if (record.qcStatus == 2) {
        return "不合格";
      } else if (record.qcStatus == 1) {
        return "合格";
      } else {
        return record.qcStatus;
      }
    },
  },
  {
    title: "原因",
    width: "50%",
    dataIndex: "qcRemark",
    customRender: (text, record, index) => {
      if (!record.qcRemark) {
        return "-";
      } else {
        return record.qcRemark;
      }
    },
  },
];
const columns2 = [
  {
    title: "序号",
    width: "100px",
    customRender: (text, record, index) => `${index + 1}`,
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
    customRender: (text, record, index) => {
      if (!record.updateTime) {
        return "-";
      } else {
        return record.updateTime;
      }
    },
  },
  {
    title: "作者",
    dataIndex: "nickName",
    width: "15%",
    customRender: (text, record, index) => {
      if (!record.nickName) {
        return "-";
      } else {
        return record.nickName;
      }
    },
  },
  {
    title: "备注内容",
    dataIndex: "message",
    width: "50%",
    customRender: (text, record, index) => {
      if (!record.message) {
        return "-";
      } else {
        return record.message;
      }
    },
  },
];
export default {
  components: { HProcess, MdToExamine, MdToLogs },
  data() {
    return {
      detailsData: {},
      qcRecordData: [],
      columns1,
      columns2,
      remarkData: [],
      backZJVisible: false,
      isAppoint: 0,
      selectRows: [],
      options: [],
      mdCheckToggle: {
        show: false,
        text: "查看",
      },
      qcToggle: {
        show: false,
        text: "查看",
      },
      remarkToggle: {
        show: false,
        text: "查看",
      },
      resultToggle: {
        show: false,
        text: "查看",
      },
      clinicalToggle: {
        show: false,
        text: "查看",
      },
      molecularToggle: {
        show: false,
        text: "查看",
      },
    };
  },
  mounted() {
    this.getLayerLst(-1);
    this.getDetails(this.$route.query.id);
    this.getQcRecordData(this.$route.query.id);
    this.getRemarkData(this.$route.query.id);
  },
  methods: {
    update() {
      this.getDetails(this.$route.query.id);
      this.$refs.mdToLogs.getComments();
    },
    closeModel() {
      this.isAppoint = 0;
      this.backZJVisible = false;
    },
    getLayerLst(id) {
      this.$get("mt/q/mtt").then((res) => {
        if (res.data.code == 1) {
          this.options = res.data.data;
        }
      });
    },
    findLabelName(v, list) {
      let data;
      (list || []).map((i) => {
        if (i.value === v) {
          data = [i.label];
        } else {
          const child = this.findLabelName(v, i.children);
          if (child) {
            data = [i.label, ...child];
          }
        }
      });
      return data;
    },
    filterMolecularTyping(aryId) {
      let aryIds = this.getSplitMolecular(aryId);
      let result = this.findLabelName(aryIds[aryIds.length - 1], this.options);
      if (result) {
        return result.join("/");
      } else {
        return "--";
      }
    },
    getSplitMolecular(param) {
      let result = [];
      if (Array.isArray(param)) {
        result = param;
      } else {
        let mtSplit = param.split(",");
        mtSplit.forEach((item, i) => {
          mtSplit[i] = item * 1;
        });
        result = mtSplit;
      }
      return result;
    },
    getDetails(id) {
      this.$get("patientitem/patientItem/detail/" + id).then((res) => {
        this.detailsData = res.data.data;
      });
    },
    getQcRecordData(id) {
      this.$get(
        "patientitem/patientItem/getQcRecordList?patientItemId=" + id
      ).then((res) => {
        this.qcRecordData = res.data.data;
      });
    },
    getRemarkData(id) {
      this.$get("patientitem/remarks?patientItemId=" + id).then((res) => {
        this.remarkData = res.data.data.records;
      });
    },
    mdToExamine() {
      if (!this.$route.query.id) {
        this.$message.warning("请选择数据后进行MD审核");
        return;
      } else {
        this.selectRows = [];
        this.selectRows.push({ id: this.$route.query.id });
        this.isAppoint = 4;
        this.backZJVisible = true;
      }
    },
    recordToggle(key) {
      this[key].show = !this[key].show;
      this[key].text = this[key].show ? "收起" : "查看";
    },
  },
};
</script>

<style lang="scss" scoped>
.diagnosis-details {
  width: 100%;
  min-width: 1200px;

  .breadcrumb {
    /deep/ .ant-breadcrumb {
      display: inline-block;
    }
  }

  .right-group {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;

    .right-group-title {
      color: #a4a4a4;
      display: inline-block;
      margin-right: 20px;
    }

    .right-group-value {
      color: #333333;
      display: inline-block;
    }
  }

  .record-group {
    font-size: 16px;
    line-height: 32px;

    .record-title {
      color: #333;
    }

    .record-link {
      float: right;
      margin-right: 10%;
    }

    .record-none {
      float: right;
      text-align: left;
      margin-right: 10%;
      font-weight: 500;
    }
  }

  .steps-div {
    margin-top: 30px;
    padding: 30px 40px;
    background: #fff;

    .ant-row+.ant-row {
      margin-top: 20px;
    }

    .steps-div-content {
      background: #eef1f5;
      padding: 20px;
    }
  }

  .diagnosis-content {
    background: #fff;
    padding-top: 60px;
    border-bottom: 1px solid #f0f2f5;

    .content {
      padding: 20px 40px 30px 40px;

      .right-group {
        display: inline-block;
      }

      .ant-row+.ant-row {
        margin-top: 30px;
      }
    }

    .header {
      padding: 0 40px;
      padding-bottom: 18px;
      border-bottom: 1px solid #f0f2f5;
      display: inline-block;
      width: 100%;

      .left {
        float: left;
      }

      .right {
        float: right;

        .right-group+.right-group {
          margin-left: 100px;
          margin-right: 18px;
        }
      }

      .name {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }

      .sex {
        margin-left: 22px;

        .anticon {
          font-size: 16px;
          color: #428ef7;
        }

        .set-text {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-left: 6px;
        }
      }

      .group {
        display: inline-block;
        height: 17px;
        font-size: 12px;
        padding: 0 10px;
        line-height: 17px;
        background: #428ef7;
        color: #fff;
        margin-left: 22px;
      }

      .create-date {
        margin-left: 70px;

        .title {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(164, 164, 164, 1);
        }

        .value {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-left: 20px;
        }
      }
    }
  }

  .page-content {
    margin: 20px 0 0;
    background: #fff;
    padding: 0 2em;

    .row-item {
      margin-bottom: 28px;
    }

    .panel-title {
      font-size: 16px;
      color: #a4a4a4;
      line-height: 59px;
      height: 59px;

      div {
        float: left;
        padding: 0px 57px 0 0;
        height: 16px;
        line-height: 16px;
        border-right: 1px solid #e1e2e5;
        margin-top: 22px;
        cursor: pointer;
      }

      div:last-child {
        border-right: none;
        padding: 0px 0 0 66px;
      }

      .active {
        font-weight: bold;
        color: #333;
      }
    }

    .panel-content {
      margin-top: 13px;
      background: rgba(249, 251, 251, 1);
      border: 1px solid rgba(240, 242, 245, 1);
      padding: 36px 0 0 0;

      .row-lable {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(164, 164, 164, 1);
      }

      .row-content {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 20px;
      }
    }
  }
}
</style>